import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FieldTextComponent, AbstractFormArrayComponent } from '@spike/scaffolds';
import { FormFactoryService } from '../../../shared/services/form-factory.service';
import { Button } from 'primeng/button';
import { TableModule } from 'primeng/table';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers:[],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FieldTextComponent, Button, TableModule],
  selector: 'spike-position-documents-form',
  templateUrl: './position-documents-form.html'
})
export class PositionDocumentsFormComponent extends AbstractFormArrayComponent{
  private readonly formFactory = inject(FormFactoryService);

  addRow = output<void>();
  deleteRow = output<number>();
  select = output<number>();

  documentForm = this.formFactory.createDocumentForm();


}
  

